<template>
    <el-dialog :title="title"
               :visible.sync="visible"
               top="10vh"
               width="580px"
               :close-on-click-modal="true"
               :modal-append-to-body="false">
        <el-form :model="dialogForm" :rules="dialogRules" ref="dialogForm"
                 size="small"
                 :label-width="$i18n.locale==='zh-CN'?'180px':'200px'">

        <!---------- 一.基本设置 ---------->
            <h3 class="tag-title">基本设置</h3>

            <!-- 考试时长 -->
            <el-form-item v-if="dialogForm.type===2 || dialogForm.type===3"
                          :label="$t('paper.testPeriod')+'：'" prop="duration">
                <el-input-number v-model="dialogForm.duration" controls-position="right" :min="0" :max="480"
                                 style="width: 80%;"></el-input-number>
            </el-form-item>

            <!-- 学时 -->
            <el-form-item :label="$t('train.hour')+'：'" prop="hours">
                <el-input-number v-model="dialogForm.hours" controls-position="right" :min="0" :max="100"></el-input-number>
            </el-form-item>

            <!-- 学分 -->
            <el-form-item :label="$t('train.credit')+'：'" prop="credit">
                <el-input-number v-model="dialogForm.credit" controls-position="right" :min="0" :max="100" ></el-input-number>

                <!-- 学分高级设置 -->
                <template v-if="dialogForm.type!==3 && dialogForm.credit">

                    <el-popover
                        placement="top-start"
                        title="高级设置"
                        width="260"
                        trigger="hover"
                    >
                        <div style="font-size: 12px;" v-if="dialogForm.type===1">
                            <p>一、请按学习时间和学分由高到低降序设置</p>
                            <p>二、请根据课件实际学习时间，设置合理的值</p>
                        </div>
                        <div style="font-size: 12px;" v-else>
                            <p>一、请按成绩和学分由高到低降序设置</p>
                            <p>二、成绩可以设为0，学分不能设为0</p>
                        </div>
                        <el-badge :value="expandNum" class="item" slot="reference">
                            <el-button @click="setExpand"
                                       class="btn-expand" icon="el-icon-s-tools" size="small">高级设置</el-button>
                        </el-badge>
                    </el-popover>
                </template>

            </el-form-item>

            <!-- 学分高级设置 -->
            <template v-if="dialogForm.type!==3 && dialogForm.credit">
                <div class="credit-expand">
                    <el-button @click="addExpand" class="credit-expand-add"
                               type="primary" icon="el-icon-plus" size="mini" circle style="margin-left: 5px;"></el-button>
                    <div class="credit-expand-item" v-for="(item, index) in dialogForm.expandSet" :key="index">
                        <p v-if="dialogForm.type===1">学习时间达到
                            <el-input-number v-model="item.percentage"
                                             :min="0"
                                             :max="index===0?1000:dialogForm.expandSet[index-1].percentage"
                                             :step="5" :precision="0"
                                             controls-position="right" size="mini" style="width:100px;"></el-input-number>
                            分钟
                        </p>
                        <p v-else>考试成绩达到
                            <el-input-number v-model="item.percentage"
                                             :min="0"
                                             :max="index===0?100:dialogForm.expandSet[index-1].percentage"
                                             :step="10" :precision="0"
                                             controls-position="right" size="mini" style="width:100px;"></el-input-number>
                            %
                        </p>
                        <p>，获得学分
                            <el-input-number v-model="item.credit"
                                             :min="0"
                                             :max="index===0?dialogForm.credit:dialogForm.expandSet[index-1].credit"
                                             controls-position="right" size="mini" style="width:100px;"></el-input-number>
                        </p>

                        <el-button @click="delExpand(index)" style="margin-left: 5px;"
                                   type="danger" icon="el-icon-minus" size="mini" circle></el-button>
                    </div>
                    <p v-if="!dialogForm.expandSet.length" class="credit-expand-empty">请添加附加条件</p>
                </div>
            </template>

            <!-- 理论课件弹窗设置 -->
            <el-form-item v-if="dialogForm.type===1 && (courseEditorItem.courseType===1 || courseEditorItem.type===1)"
                          prop="intervalTime">
                <template #label>
                    <tip-label label="弹窗设置" tip="学员多久未操作时弹窗提醒" colon />
                </template>
                <el-switch
                    v-model="intervalTimeSetting"
                    active-text="设置"
                    inactive-text="不设置">
                </el-switch>
                <template v-if="intervalTimeSetting">
                    <el-input-number v-model="dialogForm.intervalTime" controls-position="right"
                                     :min="180" :max="3600" :step="60" size="mini"
                                     style="margin: 0 10px;"></el-input-number>秒
                </template>
            </el-form-item>

            <!-- 考卷：是否乱序 -->
            <template v-if="dialogForm.type===2">
                <el-form-item :label="$t('paper.disorder')+'：'" prop="disorder">
                    <el-radio-group v-model="dialogForm.disorder">
                        <el-radio :label="true">{{$t('c.yes')}}</el-radio>
                        <el-radio :label="false">{{$t('c.no')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </template>

            <!-- 模考：通过线 -->
            <template v-if="dialogForm.type===3">
                <el-form-item :label="$t('topic.mockPassLine')+'：'" prop="passLine">
                    <el-input-number v-model="dialogForm.passLine" controls-position="right"
                                     :min="0" :max="1" :precision="2" :step="0.1"></el-input-number>
                </el-form-item>
            </template>

            <!-- 职鉴考卷&模考：走图设置 -->
            <template v-if="isFiscanType">
                <el-form-item label="考试模式：" prop="isSimulationMode">
                    <el-radio-group v-model="dialogForm.isSimulationMode">
                        <el-radio :label="false">单题</el-radio>
                        <el-radio :label="true">走图</el-radio>
                    </el-radio-group>
                </el-form-item>
            </template>

        <!---------- 二.考后设置（考卷独有） ---------->
            <template v-if="dialogForm.type===2">
                <h3 class="tag-title">考后设置</h3>

                <!-- 回查 -->
                <el-form-item :label="$t('paper.allowReview')+'：'" prop="allowReview">
                    <el-radio-group v-model="dialogForm.allowReview">
                        <el-radio :label="true">{{$t('c.yes')}}</el-radio>
                        <el-radio :label="false">{{$t('c.no')}}</el-radio>
                    </el-radio-group>
                </el-form-item>

                <!-- 答案公布时间 -->
                <el-form-item :label="$t('paper.publishTime')+'：'" v-if="dialogForm.allowReview" prop="deadline">
                    <el-date-picker type="datetime"
                                    :placeholder="$t('paper.publishTimeTip')"
                                    v-model="dialogForm.deadline"
                                    :picker-options="pickerOptions"
                                    format="yyyy-MM-dd HH:mm"
                                    value-format="yyyy-MM-dd HH:mm"
                                    style="width: 80%;"></el-date-picker>
                </el-form-item>

                <!-- 补考 -->
                <el-form-item :label="$t('paper.allowResit')+'：'" prop="allowResit">
                    <el-radio-group v-model="dialogForm.allowResit">
                        <el-radio :label="true">{{$t('c.yes')}}</el-radio>
                        <el-radio :label="false">{{$t('c.no')}}</el-radio>
                    </el-radio-group>
                    <div class="resit" v-show="dialogForm.allowResit">
                        <span>{{$t('train.resitTimes')}}：</span>
                        <el-input-number v-model="dialogForm.resit" controls-position="right" size="mini"
                                         :min="1" :max="50" :precision="0"></el-input-number>
                    </div>
                </el-form-item>

            <!---------- 三、防作弊设置 ---------->
                <h3 class="tag-title">防作弊设置</h3>

                <!-- 人脸比对 -->
                <el-form-item prop="isAntiCheating">
                    <template #label>
                        <tip-label :label="$t('paper.faceMatching')" tip="[仅APP端] 答题前开启摄像头进行人脸比对，该功能需要学员完成实名认证" colon />
                    </template>
                    <el-switch
                        v-model="dialogForm.isAntiCheating"
                        active-text="开启"
                        inactive-text="关闭">
                    </el-switch>
                </el-form-item>

                <!-- 拍照监考 -->
                <!-- 目前仅支持理论 -->
                <el-form-item prop="isMonitor" v-if="courseEditorItem.paperType===1 || courseEditorItem.type===1">
                    <template #label>
                        <tip-label label="摄像头拍照监考" tip="开启后，学员需全程开启摄像头，系统将按设定的时间频率进行抓拍，并将照片上传到监考中心" colon />
                    </template>
                    <el-switch
                        v-model="dialogForm.isMonitor"
                        active-text="开启"
                        inactive-text="关闭">
                    </el-switch>
                    <div class="resit" v-show="dialogForm.isMonitor">
                        <span>抓拍频率：</span>
                        <el-input-number v-model="dialogForm.photoDuration" controls-position="right" size="mini"
                                         :min="5" :max="6000" :precision="0"></el-input-number>
                        <span> {{ $t('paper.secondPerTime') }}</span>
                    </div>
                </el-form-item>
            </template>
        </el-form>
        <div slot="footer" style="text-align: center;margin-top: -10px;">
            <el-button type="primary" @click="dialogSave">{{$t('c.save')}}</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            courseEditor: {
                type: Boolean,
                default: false,
            },
            courseEditorItem: {
                type: Object
            }
        },
        data() {
            let validatePass = (rule, value, callback) => {
                if (value && new Date(value).getTime() < new Date().getTime()) {
                    return callback(new Error(this.$t('rule.time')));
                }
                callback();
            }

            return {
                visible: false,
                dialogForm: {
                    id: 0,
                    name: '',
                    type: 0,
                    duration: '',
                    hours: 0,
                    credit: 0,
                    intervalTime: 0,
                    deadline: '',
                    allowReview: true,
                    allowResit: false,
                    resit: 1,
                    disorder: true,
                    isSimulationMode: false,
                    isAntiCheating: false,
                    isMonitor: false,
                    photoDuration: 0,
                    passLine: 0,
                    expandSet: []
                },
                intervalTimeSetting: false,
                dialogRules: {
                    duration: [
                        {required: true, type: 'number', min: 1, message: this.$t('train.testPeriod'), trigger: 'blur'},
                        {type: 'integer', min: 1, message: this.$t('rule.int'), trigger: 'blur'}
                    ],
                    deadline: [
                        {validator: validatePass, trigger: 'blur'}
                    ],
                    credit: [
                        {validator: this.validateCredit, trigger: ['blur', 'change']}
                    ],
                },
            }
        },
        computed: {
            title() {
                let setting = {
                    1: '课件设置',
                    2: '考卷设置',
                    3: '模拟考卷设置'
                }[this.dialogForm.type]
                return `${setting} - ${this.dialogForm.name}`
            },
            pickerOptions() {
                return {
                    disabledDate(time) {
                        if (new Date(time).toDateString() === new Date().toDateString()) return false;
                        return time.getTime() < new Date().getTime()
                    },
                }
            },
            expandNum() {
                let num = 0
                if (this.dialogForm.expandSet.length) {
                    num = this.dialogForm.expandSet.filter(item => item.credit!==0).length
                }
                return num
            },
            // 是否为职鉴类型的考卷or模拟考卷
            isFiscanType() {
                const itemType = this.courseEditorItem.type || this.courseEditorItem.paperType || this.courseEditorItem.mockPaperType
                return itemType === 5
            },
        },

        methods: {
            initDialog() {
                let item = this.courseEditorItem
                console.log('item', item)

                this.dialogForm.duration = '';
                this.dialogForm.hours = '';
                this.dialogForm.credit = '';
                this.intervalTimeSetting = false;
                this.dialogForm.intervalTime = 0;
                this.dialogForm.deadline = '';
                this.dialogForm.allowReview = true;
                this.dialogForm.allowResit = false;
                this.dialogForm.resit = 1;
                this.dialogForm.disorder = true;
                this.dialogForm.isSimulationMode = false;
                this.dialogForm.isAntiCheating = false;
                this.dialogForm.isMonitor = false;
                this.dialogForm.photoDuration = 0;
                this.dialogForm.passLine = 0;
                this.dialogForm.expandSet = [];

                this.dialogForm.id = item.courseID || item.paperID || item.mockPaperID;
                this.dialogForm.name = item.title || item.courseName || item.paperName || item.mockPaperName;
                this.dialogForm.type = item.resType;  // 用于区分课件1、考试2和模拟考试3

                // 第一次选择的课件，加载默认学时学分
                if (item.resType === 1 && item.hours && item.credit) {
                    this.dialogForm.hours = item.hours
                    this.dialogForm.credit = item.credit
                }

                // 如果extra存在且不为空对象，则加载extra数据
                if (item.extra && Object.keys(item.extra).length) {
                    for (let i in item.extra) {
                        if (this.dialogForm.hasOwnProperty(i)) {
                            this.dialogForm[i] = item.extra[i];
                        }
                    }

                    if (item.resType === 1 && item.extra.intervalTime) {
                        this.intervalTimeSetting = true
                    }

                    // 若有expendSet设置则默认展开
                    if (item.resType !== 3 && item.extra.expandSet?.length) {
                        this.$nextTick(() => {
                            $('.credit-expand').show()
                        })
                    }
                }
            },

            dialogSave(){
                this.$refs['dialogForm'].validate((valid) => {
                    if (!valid) return

                    if (this.dialogForm.type === 1) {
                        if (!this.intervalTimeSetting || !this.dialogForm.intervalTime) {
                            this.dialogForm.intervalTime = 0;
                        }
                    }

                    if (this.dialogForm.type !== 3) {
                        if (this.dialogForm.credit && this.expandNum) {
                            this.dialogForm.expandSet = this.dialogForm.expandSet.filter(item => {
                                return (item.credit!==0)
                            })
                        } else {
                            this.dialogForm.expandSet = []
                        }
                    }

                    this.$emit('dialog-save', this.dialogForm)
                    this.visible = false;
                });
            },

            setExpand() {
                let $expand = $('.credit-expand')

                if ($expand.is(':visible')) {
                    $expand.slideUp();
                } else {
                    $expand.slideDown();

                    if (!this.dialogForm.expandSet.length && this.dialogForm.type !== 3) {
                        this.dialogForm.expandSet.push({
                            percentage: 0,
                            credit: this.dialogForm.credit
                        })
                    }
                }
            },
            addExpand() {
                if (this.dialogForm.type !== 3) {
                    this.dialogForm.expandSet.push({
                        percentage: 0,
                        credit: 0
                    })
                }
            },
            delExpand(index) {
                this.dialogForm.expandSet.splice(index, 1)
            },

            validateCredit(rule, value, callback) {
                if (value !==0 && this.dialogForm.type !== 3 && this.expandNum) {
                    if (this.dialogForm.expandSet.find(v => v.credit > value)) {
                        return callback(new Error('此处的学分不可小于高级设置中的学分！'));
                    }

                }
                callback()
            }
        },

        watch: {
            visible(val) {
                // 打开
                if (val) {
                    this.initDialog();
                    // 关闭
                } else {
                    this.$refs.dialogForm.clearValidate()

                    this.$emit('update:courseEditor', false)
                }
            },
            courseEditor() {
                this.visible = this.courseEditor;
            },
            "dialogForm.credit"(v) {
                if (this.dialogForm.type !== 3 && v===0) {
                    this.dialogForm.expandSet = []
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    .btn-expand {
        margin-left: 8px;
    }

    .credit-expand {
        display: none;
        position: relative;
        margin-bottom: 10px;
        padding: 8px 0 8px 10px;
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #ddd;

        .credit-expand-item {
            padding: 10px 0;
            > p {
                display: inline-block;
            }
        }

        .credit-expand-add {
            position: absolute;
            right: 0;
            top: 50%;
            margin-top: -14px;
        }

        .credit-expand-empty {
            padding: 5px 0;
            color: #999;
            text-align: center;
        }
    }

    .resit {
        display: inline-block;
        margin-left: 20px;
        .el-input-number {
            width: 110px;
        }
    }

    .cheat-tip {
        font-size: 16px;
        vertical-align: middle;
        color: #999;
        margin-left: 5px;
    }

    .tag-title {
        margin-left: 5px;
        margin-bottom: 10px;
        padding: 2px 10px;
        font-weight: 600;
        border-left: 4px solid $blue;
    }
</style>
